import React from 'react';
import api from '../config/api';
import { DomainCard } from './DomainCard';
import { Globe } from 'lucide-react';

export function DomainList() {
  const [domains, setDomains] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    fetchDomains();
  }, []);

  async function fetchDomains() {
    try {
      setLoading(true);
      const response = await api.get('/api/domains');
      setDomains(response.data.domains || []);
    } catch (err) {
      const message = err.response?.data?.error || 'Failed to fetch domains';
      setError(message);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-slate-500 font-medium">Loading domains...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-rose-50 border border-rose-200 text-rose-700 px-4 py-3 rounded-lg text-sm">
        {error}
      </div>
    );
  }

  if (!domains.length) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-12 text-center">
        <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4 text-slate-400">
          <Globe size={32} />
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-2">No domains yet</h3>
        <p className="text-slate-500 max-w-sm mx-auto">
          Add your first domain above to start receiving emails with your custom branding.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {domains.map(domain => (
        <DomainCard
          key={domain.id}
          domain={domain}
          onRefresh={fetchDomains}
        />
      ))}
    </div>
  );
}
